import { render } from "./LMSYSBotSettings.vue?vue&type=template&id=03928a8c"
import script from "./LMSYSBotSettings.vue?vue&type=script&lang=js"
export * from "./LMSYSBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__